module.exports = __webpack_public_path__ + "static/media/menu-3.80280f17.jpg";